/* eslint-disable react/prop-types */
import React from "react";
import {
  Typography,
  Box,
  Tooltip,
  useMediaQuery,
  makeStyles,
} from "@material-ui/core";
import { FaRegCalendarAlt, FaUser } from "react-icons/fa";
import { AiOutlineComment } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { changeSelectedScenarioAsyncAction } from "app/scenarios/duck/actions";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { BsTrash, BsFiles, BsPencil } from "react-icons/bs";
import { ReactComponent as ImportCsvIcon } from "resources/import-csv-icon.svg";
import { ReactComponent as StarIcon } from "resources/star-icon.svg";
import Fab from "@material-ui/core/Fab";
import { RiFileExcel2Line } from "react-icons/ri";
import mixpanelTrack from "app/common/MixpanelComponent";
import withExportScenario from "app/common/scenario/withExportScenario";
import withDeleteScenario from "app/common/scenario/withDeleteScenario";
import withCopyScenario from "app/common/scenario/copy/withCopyScenario";
import withImportScenario from "app/common/scenario/import/withImportScenario";
import withStarredScenario from "app/common/scenario/withStarredScenario";
import withEditScenario from "app/common/scenario/withEditScenario";
import computeScenarioTotalsForCard from "lib/utils/scenarios";
import { CgChart } from "react-icons/cg";
import CannibalizationTooltipComponent from "app/cannibalization/CannibalizationTooltipComponent";
import ScenarioTotalsCardComponent from "./map/ScenarioTotalsCardComponent";

const useStyles = makeStyles((theme) => ({
  scenarioOptionContainer: {
    display: "flex",
    "&:hover": {
      cursor: "pointer",
      boxShadow:
        "inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15)",
      "& $hide": {
        visibility: "visible",
      },
    },
  },
  icon: {
    color: "gray",
  },
  borderBarTop: {
    borderTop: "1px solid #e2e2e2",
  },
  borderBarTopContainer: {
    paddingBottom: "2px",
  },
  totalsContainer: {
    marginTop: "12px",
    flexFlow: "column",
    justifyContent: "center",
    padding: theme.spacing(1.5, 2.5),
    backgroundColor: "#fafafa",
    position: "relative",
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      flexBasis: "250px",
    },
  },
  scenarioMetadata: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      width: "350px",
    },
    padding: theme.spacing(1.5, 2.5),
    position: "relative",
  },
  totalsItem: {
    paddingTop: "3px",
    paddingBottom: "3px",
  },
  footerItem: {
    color: "#6e6e6e",
  },
  withLeftPadding: {
    paddingLeft: "5px",
  },
  scenarioOptionFooter: {
    justifyContent: "space-between",
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
  totalsItemValue: {
    display: "flex",
    alignItems: "center",
    marginLeft: "10px",
    "& > span": {
      marginLeft: "3px",
    },
    minWidth: "55px",
  },
  uncontrolledText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
  },
  withTopMargin: {
    marginTop: "5px",
  },
  shortcutsContainer: {
    marginLeft: "1px",
    position: "absolute",
    width: "100%",
    backgroundColor: "#fff",
    top: 120,
    "&> *": {
      backgroundColor: "white",
      boxShadow: "none",
      color: theme.palette.text.primary,
      "&:hover": {
        color: theme.palette.text.secondary,
      },
    },
  },
  shortcutsContainerSmall: {
    marginLeft: "1px",
    position: "absolute",
    width: "100%",
    backgroundColor: "#fff",
    top: 232,
    "&> *": {
      backgroundColor: "white",
      boxShadow: "none",
      color: theme.palette.text.primary,
      "&:hover": {
        color: theme.palette.text.secondary,
      },
    },
  },
  hide: {
    visibility: "hidden",
  },
  contextMenuItemWithIcon: {
    "& > svg": {
      marginRight: "12px",
    },
  },
  scenarioOptionSpan: {
    overflow: "hidden",
  },
  columnLayout: {
    flexDirection: "column",
  },
  disabledFab: {
    color: "rgba(0, 0, 0, 0.26)",
    backgroundColor: "transparent",
  },
  enabledFab: {
    color: "dark",
  },
}));

const initialContextMenuState = {
  mouseX: null,
  mouseY: null,
};

const ScenarioOptionComponent = ({
  scenarioTotal,
  visibleScenarios,
  referenceScenarioTotal,
  metadata,
  closeParentPopover,
  haveShortcutsBar = true,
  showPercentages = true,
  isCompetitors = false,
  setMainScenarioData,
  setBaseCompetitorScenarioData,
  setBaseCompetitorKpis,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleMixPanelTrack = () => {
    /* MIXPANEL TRACKS */
    mixpanelTrack(`Saved edit base escenario`);
    /* END OF MIXPANEL TRACKS */
  };

  const handleScenarioClick = () => {
    closeParentPopover(null);
    if (isCompetitors) {
      handleMixPanelTrack();
      setMainScenarioData(null);
      setBaseCompetitorScenarioData(null);
      setBaseCompetitorKpis(null);
    }
    // dispatch(resetSelectedScenario());
    dispatch(changeSelectedScenarioAsyncAction(scenarioTotal.scenario.id));
  };
  const configCatSlice = useSelector((state) => state.auth.configCatUser);

  const [contextMenuState, setContextMenuState] = React.useState(
    initialContextMenuState
  );

  const handleContextMenuClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setContextMenuState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleContextMenuClose = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setContextMenuState(initialContextMenuState);
  };

  const MenuItemWithDeleteScenario = withDeleteScenario((props) => {
    return (
      <MenuItem
        disabled={configCatSlice?.features?.IsMaintenanceActive}
        className={classes.contextMenuItemWithIcon}
        onClick={props.onClick}
      >
        <BsTrash size={18} />
        Delete scenario
      </MenuItem>
    );
  }, scenarioTotal.scenario);

  const MenuItemWithExportScenario = withExportScenario((props) => {
    return (
      <MenuItem
        className={classes.contextMenuItemWithIcon}
        onClick={props.onClick}
      >
        <RiFileExcel2Line size={18} />
        Export to Excel
      </MenuItem>
    );
  }, scenarioTotal.scenario);

  const MenuItemwithImportScenario = withImportScenario((props) => {
    return (
      <MenuItem
        disabled={configCatSlice?.features?.IsMaintenanceActive}
        className={classes.contextMenuItemWithIcon}
        onClick={
          configCatSlice?.features?.IsMaintenanceActive
            ? undefined
            : props.onClick
        }
      >
        <BsFiles size={18} />
        Copy scenario
      </MenuItem>
    );
  }, scenarioTotal);

  const MenuItemwithCopyScenario = withCopyScenario((props) => {
    return (
      <MenuItem
        disabled={configCatSlice?.features?.IsMaintenanceActive}
        className={classes.contextMenuItemWithIcon}
        onClick={
          configCatSlice?.features?.IsMaintenanceActive
            ? undefined
            : props.onClick
        }
      >
        <BsFiles size={18} />
        Copy scenario
      </MenuItem>
    );
  }, scenarioTotal);

  const MenuItemWithEditScenario = withEditScenario((props) => {
    return (
      <MenuItem
        disabled={configCatSlice?.features?.IsMaintenanceActive}
        className={classes.contextMenuItemWithIcon}
        onClick={
          configCatSlice?.features?.IsMaintenanceActive
            ? undefined
            : props.onClick
        }
      >
        <BsPencil size={18} />
        Edit scenario
      </MenuItem>
    );
  }, scenarioTotal);

  const ContextMenu = () => (
    <Menu
      keepMounted
      open={contextMenuState.mouseY !== null}
      onClose={handleContextMenuClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenuState.mouseY !== null && contextMenuState.mouseX !== null
          ? { top: contextMenuState.mouseY, left: contextMenuState.mouseX }
          : undefined
      }
      onContextMenu={handleContextMenuClose}
    >
      {/* This "double IF" is duplicated instead of joined inside a conditional
      React.Fragment, i.e. <></>, for two reasons:
          - All items are siblings, and a React.Fragment is equivalent to a div
          - Menu component cannot accept a React.Fragment as child  */}
      {scenarioTotal.scenario.id !== referenceScenarioTotal.scenario.id && (
        <MenuItemWithDeleteScenario onDialogClose={handleContextMenuClose} />
      )}
      {scenarioTotal.scenario.id !== referenceScenarioTotal.scenario.id && (
        <MenuItemWithEditScenario onDialogClose={handleContextMenuClose} />
      )}
      <MenuItemwithImportScenario onDialogClose={handleContextMenuClose} />
      <MenuItemWithExportScenario afterClick={handleContextMenuClose} />
      <MenuItemwithCopyScenario onDialogClose={handleContextMenuClose} />
    </Menu>
  );

  const FabWithDeleteScenario = withDeleteScenario((props) => {
    return (
      <Tooltip
        title={
          configCatSlice?.features?.IsMaintenanceActive
            ? "Delete scenario Disabled"
            : "Delete scenario"
        }
      >
        <Fab
          size="small"
          className={
            configCatSlice?.features?.IsMaintenanceActive
              ? classes.disabledFab
              : classes.enabledFab
          }
          style={{ marginLeft: isSmallScreen ? "3px" : "20px" }}
          onClick={
            configCatSlice?.features?.IsMaintenanceActive
              ? undefined
              : props.onClick
          }
        >
          <BsTrash size={18} className={classes.icon} />
        </Fab>
      </Tooltip>
    );
  }, scenarioTotal.scenario);

  const FabWithExportScenario = withExportScenario((props) => {
    return (
      <Tooltip title="Export to Excel">
        <Fab
          size="small"
          onClick={props.onClick}
          style={{ marginLeft: isSmallScreen ? "3px" : "20px" }}
        >
          <RiFileExcel2Line size={18} className={classes.icon} />
        </Fab>
      </Tooltip>
    );
  }, scenarioTotal.scenario);

  const FabWithImportCsv = withImportScenario((props) => {
    return (
      <Tooltip title="Import prices from .csv">
        <Fab
          size="small"
          onClick={props.onClick}
          style={{ marginLeft: isSmallScreen ? "3px" : "20px" }}
        >
          <ImportCsvIcon size={18} />
        </Fab>
      </Tooltip>
    );
  }, scenarioTotal);

  // .scenario

  const FabwithCopyScenario = withCopyScenario((props) => {
    return (
      <Tooltip
        title={
          configCatSlice?.features?.IsMaintenanceActive
            ? "Copy scenario Disabled"
            : "Copy scenario"
        }
        disableFocusListener
      >
        <Fab
          size="small"
          className={
            configCatSlice?.features?.IsMaintenanceActive
              ? classes.disabledFab
              : classes.enabledFab
          }
          style={{ marginLeft: "8px" }}
          onClick={
            configCatSlice?.features?.IsMaintenanceActive
              ? undefined
              : props.onClick
          }
        >
          <BsFiles size={18} className={classes.icon} />
        </Fab>
      </Tooltip>
    );
  }, scenarioTotal);

  const FabWithEditScenario = withEditScenario((props) => {
    return (
      <Tooltip
        title={
          configCatSlice?.features?.IsMaintenanceActive
            ? "Edit scenario Disabled"
            : "Edit scenario"
        }
      >
        <Fab
          size="small"
          className={
            configCatSlice?.features?.IsMaintenanceActive
              ? classes.disabledFab
              : classes.enabledFab
          }
          style={{ marginLeft: isSmallScreen ? "3px" : "20px" }}
          onClick={
            configCatSlice?.features?.IsMaintenanceActive
              ? undefined
              : props.onClick
          }
        >
          <BsPencil size={18} className={classes.icon} />
        </Fab>
      </Tooltip>
    );
  }, scenarioTotal);

  const FabWithStarredScenario = withStarredScenario(
    (props) => {
      return (
        <Tooltip
          title={
            configCatSlice?.features?.IsMaintenanceActive
              ? "Star scenario Disabled"
              : "Star scenario"
          }
        >
          <Fab
            size="small"
            className={
              configCatSlice?.features?.IsMaintenanceActive
                ? classes.disabledFab
                : classes.enabledFab
            }
            style={{ marginLeft: isSmallScreen ? "3px" : "20px" }}
            onClick={
              configCatSlice?.features?.IsMaintenanceActive
                ? undefined
                : props.onClick
            }
          >
            <StarIcon size={18} className={classes.icon} />
          </Fab>
        </Tooltip>
      );
    },
    scenarioTotal,
    visibleScenarios
  );

  return (
    <div
      className={`${classes.scenarioOptionContainer} ${isSmallScreen &&
        classes.columnLayout}`}
      style={{
        height: haveShortcutsBar
          ? `${isSmallScreen ? 275 : 165}px`
          : `${isSmallScreen ? 235 : 125}px`,
      }}
      role="presentation"
      onClick={() => handleScenarioClick()}
      onContextMenu={handleContextMenuClick}
    >
      <ContextMenu />

      <div className={classes.scenarioMetadata}>
        <Box
          component="span"
          className={`${classes.scenarioOptionSpan} ${classes.footerItem} ${classes.alignCenterFlex}`}
        >
          {/* <Tooltip title={scenarioTotal.scenario.name} placement="right"> */}
          <Typography variant="body1" className={classes.uncontrolledText}>
            <b>{scenarioTotal.scenario.name}</b>
          </Typography>
          {/* </Tooltip> */}
          {scenarioTotal.scenario.is_starred && (
            <StarIcon
              size={18}
              className={classes.icon}
              style={{ marginLeft: "8px" }}
            />
          )}
          {scenarioTotal.scenario.is_blocked && (
            <CannibalizationTooltipComponent
              placement="right"
              iconComponent={
                <CgChart fontSize={18} style={{ marginLeft: "4px" }} />
              }
              isCustomTooltip={false}
            />
          )}
        </Box>

        <Box
          component="span"
          className={`${classes.scenarioOptionSpan} ${classes.alignCenterFlex} ${classes.withTopMargin}`}
        >
          <AiOutlineComment />
          <Tooltip
            title={scenarioTotal.scenario.comment || "-"}
            placement="right"
          >
            <Typography
              variant="body2"
              className={`${classes.withLeftPadding} ${classes.uncontrolledText}`}
            >
              {scenarioTotal.scenario.comment || "-"}
            </Typography>
          </Tooltip>
        </Box>

        <Box
          component="span"
          className={` ${classes.scenarioOptionSpan} ${classes.alignCenterFlex} ${classes.withTopMargin}`}
        >
          {" "}
          <FaRegCalendarAlt />
          <Tooltip title={scenarioTotal.scenario.cycle.label} placement="right">
            <Typography
              variant="body2"
              className={`${classes.withLeftPadding} ${classes.uncontrolledText}`}
            >
              {scenarioTotal.scenario.cycle.label}
            </Typography>
          </Tooltip>
        </Box>

        <Box
          component="span"
          className={`${classes.alignCenterFlex} ${classes.scenarioOptionFooter}`}
        >
          <Box
            component="span"
            className={`${classes.scenarioOptionSpan} ${classes.footerItem} ${classes.alignCenterFlex} ${classes.withTopMargin}`}
          >
            {" "}
            <FaUser />
            <Tooltip
              title={scenarioTotal.scenario.owner_label}
              placement="right"
            >
              <Typography
                variant="body2"
                className={`${classes.withLeftPadding} ${classes.uncontrolledText}`}
              >
                {scenarioTotal.scenario.owner_label}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
      </div>

      <div className={classes.totalsContainer}>
        <ScenarioTotalsCardComponent
          isReference={scenarioTotal.scenario_type === 1}
          cardData={computeScenarioTotalsForCard(
            scenarioTotal,
            referenceScenarioTotal
          )}
          showInChart
          orderWithVisibleKeys
          visibleKeys={["units", "sales", "margin", "price"]}
          metadata={metadata}
          row={isSmallScreen}
          showPercentages={showPercentages}
        />
      </div>

      {haveShortcutsBar && (
        <Box
          className={`${
            isSmallScreen
              ? classes.shortcutsContainerSmall
              : classes.shortcutsContainer
          } ${classes.hide}`}
        >
          <Box className={classes.borderBarTopContainer}>
            <div className={classes.borderBarTop} />
          </Box>
          <FabwithCopyScenario />
          <FabWithExportScenario />
          <FabWithImportCsv />
          {scenarioTotal.scenario.id !== referenceScenarioTotal.scenario.id && (
            <>
              <FabWithDeleteScenario />
              <FabWithEditScenario />
              <FabWithStarredScenario />
            </>
          )}
        </Box>
      )}
    </div>
  );
};

export default ScenarioOptionComponent;
